var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngular0Dc5748E(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_angular"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.7333 4L34.4667 9.25L32.2333 28.75L19.7333 35.6667L7.23333 28.75L5 9.25L19.7333 4ZM19.7333 7.5L10.5167 28.1667H13.95L15.8 23.5333H23.6333L25.4833 28.1667H28.9L19.7333 7.5ZM22.4333 20.6667H17.05L19.7333 14.2167L22.4333 20.6667Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngular0Dc5748E);
export default __webpack_public_path__ + "static/media/angular-0dc5748e.2c3beaf073c90de4fa2ebb0f6bb58c9a.svg";
export { ForwardRef as ReactComponent };